import { DisplayOrder } from '@ravago/shared/page-data/models/elements';

export async function getOrders(isOpen: boolean): Promise<DisplayOrder[]> {
  const response = await fetch(`/api/orders/?isOpen=${isOpen}`);

  if (!response.ok) {
    return [];
  }

  return response.json();
}
